import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, coreTheme } from "@kolmeo/ui-core";
const { palette, spacing, borderRadius } = coreTheme;
const PillItem = ({ text, rightElement, textProps, ...props }) => {
    return (_jsxs(Box, { borderWidth: 1, alignItems: "center", borderRadius: borderRadius.radius36, flexDirection: "row", justifyContent: "center", ...props, children: [text ? (_jsx(Text, { variant: "label12SemiBold", color: palette.textSecondary, marginRight: rightElement ? `${spacing.spacing8}px` : 0, ...textProps, children: text })) : null, rightElement && rightElement] }));
};
export default PillItem;
